import expandEditorCss from '!!raw-loader!./ExpandEditor.css';
import _ from 'lodash';

let css, overlay;

/**
 * Custom module for quilljs to expand editor to fill a larger area
 */
export class ExpandEditor {
	constructor(quill, options = '') {
		// save the quill reference
		this.quill = quill;
		// bind handlers to this instance
		this.expandTo = options || 'body';
		if (!css) {
			this._addCss();
		}
		if (!overlay) {
			this._setupOverlay();
		}
		setTimeout(() => this._setupToolbar(), 0);
	}

	_addCss() {
		css = document.createElement('style');
		css.textContent = expandEditorCss;
		document.body.appendChild(css);
	}

	_setupOverlay() {
		overlay = document.createElement('div');
		overlay.className = 'quill-expand-overlay';
	}

	_setupToolbar() {
		this.isExpanded = false;
		const toolbar = this.quill.theme.modules.toolbar.container;
		this.quillContainer = toolbar.parentNode;
		this.button = toolbar.querySelector('.ql-expand');
		this.quill.getModule('toolbar').addHandler('expand', () => {
			if (this.isExpanded) {
				this.shrink();
			} else {
				this.expand();
			}
			this.isExpanded = !this.isExpanded;
		});
		this.overlay = document.createElement('div');
	}

	expand() {
		const onto = document.querySelector(this.expandTo);
		if (!onto) {
			return;
		}
		if (!_.includes(['fixed', 'absolute'], onto.style.position)) {
			onto.style.position = 'relative';
		}
		this.oldParent = this.quillContainer.parentNode;
		overlay.appendChild(this.quillContainer);
		onto.appendChild(overlay);
		this.button.classList.add('is-expanded');
	}

	shrink() {
		// assumption: quillContainer is the only child of oldParent
		this.oldParent.appendChild(this.quillContainer);
		overlay.parentNode.removeChild(overlay);
		this.button.classList.remove('is-expanded');
	}
}
